import { compose } from 'redux';
import { connect } from 'react-redux';
import withBaseDrawer from 'components/common/Drawers/withBaseDrawer';
import { getAdvancedMfn } from 'redux-core/productions/selectors';
import { setAdvancedMfn } from 'redux-core/productions/actions';

const mapStateToProps = (state) => ({
  advancedMfn: getAdvancedMfn(state),
});

const mapDispatchToProps = { setAdvancedMfn };

export default compose(connect(mapStateToProps, mapDispatchToProps), withBaseDrawer);
